import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cn, tailwind, typography } from "@/utilities/tailwind-utils";

function Label({
  className,
  disabled,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root> & { disabled?: boolean }) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        tailwind.components.label,
        disabled && typography.textMuted,
        className
      )}
      {...props}
    />
  );
}

export { Label };
